import { jsx as _jsx } from "react/jsx-runtime";
import Cookies from 'js-cookie';
import { createContext, useMemo, useRef } from 'react';
import { useLocation } from 'react-router';
function generateId() {
    return crypto.randomUUID();
}
const defaultContextValue = {
    contextEntity: undefined,
    onTrigger: () => { },
    onInitiate: () => { },
    onSelect: () => { },
    onComplete: () => { },
};
export const SignInEntityContext = createContext(defaultContextValue);
export function SignInEntityContextProvider({ trigger, children, }) {
    const { search } = useLocation();
    const entityRef = useRef(undefined);
    const searchParams = new URLSearchParams(search);
    const fixedAuthId = searchParams.get('authId');
    const initialAuthMethodId = searchParams.get('authMethodId');
    const contextValue = useMemo(() => {
        const isIdGenerationAvailable = typeof (crypto === null || crypto === void 0 ? void 0 : crypto.randomUUID) === 'function';
        if (!isIdGenerationAvailable) {
            console.error('crypto.randomUUID is not available, cannot generate meaningful auth/authMethod ids! all logic will be disabled');
            return defaultContextValue;
        }
        function getEntityScaffold(stage) {
            return {
                SCHEMA_KEY: 'SignIn301',
                auth_id: fixedAuthId || generateId(),
                stage,
                trigger: trigger !== null && trigger !== void 0 ? trigger : 'UNKNOWN',
                auth_cookie_detected: !!Cookies.get('ursid'),
                methods_available: undefined,
                auth_method_identifier: !entityRef.current && initialAuthMethodId ? initialAuthMethodId : undefined,
                method_selected: undefined,
            };
        }
        return {
            get contextEntity() {
                return entityRef.current;
            },
            onTrigger() {
                entityRef.current = getEntityScaffold('TRIGGER');
            },
            onInitiate(methodsAvailable) {
                var _a;
                const isNewAuthFlow = ((_a = entityRef.current) === null || _a === void 0 ? void 0 : _a.stage) !== 'TRIGGER' && !fixedAuthId;
                const entityToContinueFrom = !isNewAuthFlow ? entityRef.current : undefined;
                if (entityToContinueFrom) {
                    entityRef.current = Object.assign(Object.assign({}, entityToContinueFrom), { stage: 'INITIATE', methods_available: methodsAvailable, method_selected: undefined });
                }
                else {
                    entityRef.current = Object.assign(Object.assign({}, getEntityScaffold('INITIATE')), { methods_available: methodsAvailable });
                }
            },
            onSelect(method) {
                if (!entityRef.current) {
                    console.error('onSelect was called when the entity is not initialised - this should not have happened');
                    return;
                }
                entityRef.current = Object.assign(Object.assign({}, entityRef.current), { stage: 'SELECT', auth_method_identifier: generateId(), methods_available: undefined, method_selected: method });
            },
            onComplete() {
                if (!entityRef.current) {
                    console.error('onComplete was called when the entity is not initialised - this should not have happened');
                    return;
                }
                entityRef.current = Object.assign(Object.assign({}, entityRef.current), { stage: 'COMPLETION' });
            },
        };
    }, [fixedAuthId, initialAuthMethodId, trigger]);
    return _jsx(SignInEntityContext.Provider, { value: contextValue, children: children });
}
